/*
 * Created Date: 22-01-2024, 5:00:13 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Wed Jan 24 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'
class Onboarding extends BaseService {
	checkOnboarding = () => {
		const endpoint = `/workspace/studio/api/v1/auth/check-onboarding`
		return this.request.get(endpoint)
	}

	updateStepProfile = data => {
		const endpoint = `/workspace/studio/api/v1/auth/onboarding/profile`
		return this.request.post(endpoint, data)
	}

	updateStepFavourite = data => {
		const endpoint = `/workspace/studio/api/v1/auth/onboarding/favorite`
		return this.request.post(endpoint, data)
	}

	updateStepHearAbout = data => {
		const endpoint = `/workspace/studio/api/v1/auth/onboarding/hear-about?telescope=1`
		return this.request.post(endpoint, data)
	}

	sendOTP = data => {
		const endpoint = `/workspace/studio/api/v1/auth/onboarding/send-otp?telescope=1`
		return this.request.post(endpoint, data)
	}

	verifyOTP = data => {
		const endpoint = `/workspace/studio/api/v1/auth/onboarding/verify-otp?telescope=1`
		return this.request.post(endpoint, data)
	}
}

const onboardingSerivce = new Onboarding()

export default onboardingSerivce
